export enum enumValidationMessageSeverity {
  ERROR = 'error',
  WARNING = 'warning',
}
